import { Button } from "@components/ui"
import NextHead from "next/head"

export const baseUrl = "https://basedinstitute.deframe.it"

function Page() {
  return (
    <>
      <NextHead>
        <meta property="fc:frame" content="vNext" />
        <meta
          property="fc:frame:image"
          content={`${baseUrl}/frames-assets/base-drop/default.jpg`}
        />
        <meta
          property="fc:frame:post_url"
          content={`${baseUrl}/api/frames/base-drop`}
        />
        <meta property="fc:frame:button:1" content="Claim" />
        <meta property="fc:frame:button:2" content="Based definition" />
        <meta property="fc:frame:button:2:action" content="post_redirect" />
      </NextHead>
      <div className="text-center">
        <div className="pb-6 mx-auto prose">
          <p>Claim the Base Drop on Farcaster.</p>
          <p className="text-sm text-gray-600">
            If you don&apos;t see the claim button, make sure you are on the
            latest version of Warpcast
          </p>
        </div>
        {/* TODO: generalize URL to be dynamic */}
        <Button label="Go to Farcaster" href="https://warpcast.com" />
      </div>
    </>
  )
}

export default Page
